import React, {Component} from 'react';
import PropTypes from 'prop-types';
import '../assets/css/style.css';

/**
 * Component Tabs
 */
class Tabs extends Component {
  /**
   * Constructor
   * @param{object} props
   */
  constructor(props) {
    super(props);
    const {active=0} = props;
    this.state = {
      active: (active*2),
    };
  }

  /**
   * Handle selecting a tab
   * @param{number} i
   * @return {function(): void}
   */
  select(i) {
    const _this = this;
    return function() {
      _this.setState({
        active: i,
      });
    };
  }

  /**
   * Render tab index
   * @return {React.ReactNode}
   */
  renderTabs() {
    return React.Children.map(this.props.children, (item, i) => {
      if (i % 2 === 0) {
        const active = this.state.active === i ? 'active' : '';
        return <button type={'button'} onClick={this.select(i)}
          className={`${active} tab`}>{item}</button>;
      }
    });
  }

  /**
   * Render Tab content
   * @return {React.ReactNode}
   */
  renderContent() {
    return React.Children.map(this.props.children, (item, i) => {
      if (i - 1 === this.state.active) {
        return <div className='tabsContent'>{item}</div>;
      } else {
        return '';
      }
    });
  }

  /**
   * Render component
   * @return {JSX.Element}
   */
  render() {
    return (
      <div className="tabs">
        {this.renderTabs()}
        {this.renderContent()}
      </div>
    );
  }
}

Tabs.propTypes = {
  children: PropTypes.node,
  active: PropTypes.number,
};

export default Tabs;
